import { Label, TextArea } from '@iwoca/orion';
import { Trans, useLingui } from '@lingui/react/macro';
import { clsx } from 'clsx';
import { useFormContext } from 'react-hook-form';

import { TGetStartedDataDE } from './GetStartedDE';
import styles from './GetStartedDE.module.css';

const DetailedPurposeDE = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<TGetStartedDataDE>();

  const { t } = useLingui();

  const { watch } = useFormContext<TGetStartedDataDE>();

  const additionalInformationRequired = watch('loanPurpose') === 'other';

  return (
    <div>
      <Label htmlFor="loanPurposeDetails">
        <Trans>Additional Information</Trans>
        {!additionalInformationRequired && (
          <span className={styles.optional}>
            {' '}
            (<Trans>optional</Trans>)
          </span>
        )}
      </Label>
      <TextArea
        {...register('loanPurposeDetails')}
        placeholder={t`Please enter a purpose`}
        className={clsx(styles.loanPurposeDetails, {
          [styles.erroredSelect]: errors.loanPurposeDetails?.message,
        })}
        error={errors.loanPurposeDetails?.message}
      />
    </div>
  );
};

export default DetailedPurposeDE;
